import { v4 as uuidv4 } from 'uuid';
import { getStableClientId } from './clientId';
import type { PlaceBetPayload, SelectionWithMarket } from '../store/types';

export function createBetPayload(
  selection: SelectionWithMarket,
  amount: number
): PlaceBetPayload {
  return {
    clientBetId: uuidv4(),
    amount,
    selectionId: selection.id,
    priceId: selection.backPrices[0]?.id,
    marketId: selection.marketId,
    roundId: selection.roundId,
    clientId: getStableClientId(),
    userPlacedTime: new Date().toISOString(),
    side: selection.backPrices[0]?.side,
    gameId: selection.gameId,
  };
}
